import { createSlice } from '@reduxjs/toolkit';
import client from 'api/apiClient';
import { createAsyncThunkWrapper } from 'redux/thunk/createAsyncThunkWrapper';
import { PaginationHeaders } from 'types/common';
import { getDefaultCompanyId } from 'utils/helpers';

interface parishTypes {
    data: any;
    loading: boolean;
    error: string | null;
    loadMore: boolean;
}

const initialState: parishTypes = {
    data: [],
    loading: false,
    error: null,
    loadMore: false,
};
interface FetchParishDataPayload {
    searchText?: any;
    headers?: PaginationHeaders;
}

export const fetchParishData = createAsyncThunkWrapper<any, FetchParishDataPayload>(
    'parish/fetchParishData',
    async ({ searchText, headers }: FetchParishDataPayload, { getState }) => {
        const { pageSize = 10, pageNumber = 0 } = headers || {};
        let Response: any;
        if (searchText) {
            Response = await client.get('/merchant/searchCompany', {
                headers: {
                    searchText,
                },
            });
            return { data: Response?.merchants || [], pageSize, pageNumber };
        } else {
            const state: any = getState();
            const companyId = getDefaultCompanyId(state);
            if (!companyId) return;
            Response = await client.post('/merchant/getProviderChildren', {}, { ...headers, companyId });
            return { data: Response?.merchants || [], pageSize, pageNumber };
        }
    }
);

const parishSlice = createSlice({
    name: 'parish',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchParishData.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchParishData.fulfilled, (state, action) => {
            state.loading = false;
            const { payload } = action;
            if (!payload) return;
            const { data, pageSize, pageNumber } = payload || {};
            state.loadMore = data?.length >= pageSize;

            state.data = pageNumber ? [...state?.data, ...(data || [])] : data;
        });
        builder.addCase(fetchParishData.rejected, (state, action) => {
            state.loading = false;
            state.error = action?.error?.message || null;
        });
    },
});

export default parishSlice.reducer;
